import { render, staticRenderFns } from "./zhuceProto.vue?vue&type=template&id=5ff375b1&scoped=true"
import script from "./zhuceProto.vue?vue&type=script&lang=js"
export * from "./zhuceProto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff375b1",
  null
  
)

export default component.exports